module.exports = __webpack_public_path__ + "img/tg-icon.f2f2e907.svg";